(function (global) {

  /**
  * Функции отвечающие за работу карточек.
  * @namespace Core.cards
  * @since 5.0.0.7100
  */
  global.cards = {};
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Удаление строки детального раздела.
  * @function Core.cards.deleteTableRow
  * @since 5.0.0.7100
  * @return Core.cards
  */
  global.cards.deleteTableRow = function (el, rowNum) {
    ConfirmDialogNew({
      text: L("CONFIRM_TABLE_RECORD_DELETE"),
      okText: L("YES"),
      cancelText: L("NO"),
      ok: function () {
        var tbl = $(el).parents().filter('table:first');
        var detailNum = +tbl.data('section');
        WA.CR.form.controls.tables[tbl.data('name')].deleteRow(+rowNum);
      }
    });
    return this;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Установить доступность кнопок.
  * @since 5.5.2201
  */
  global.cards.enableButtonsOnFormChange = function (buttonNames) {    
    var toolBar = WA.CR.toolBar;
    if (toolBar) {
      buttonNames.forEach(function (buttonName) {
        var button = toolBar.buttons[buttonName];
        if (button) {
          button.enable();
        }
      });
    }
  };
  //---------------------------------------------------------------------//

  /**
  * Установить доступность кнопок на ленте при изменении формы.
  * @since 5.5.2201
  */
  global.cards.bindButtonsEnablingOnFormChange = function (buttonNames) {
    // Флаг, указывающий необходимость осуществления блокировки кнопок не ленте
    // на основе режима доступности
    var isControlChangedBefore = false;
    $.when(WA.FormControlsInit, WA.FormInit, WA.ToolBarInit).done(() => {     
      WA.CR.form.bind('change', () => {
        global.cards.enableButtonsOnFormChange(buttonNames);
        if (!isControlChangedBefore) {
          Core.cards.setButtonsEnablingOnEnabledMode();
          isControlChangedBefore = true;
        }
      });

      //подписываем реквизиты карточки на события ввода
      bindButtonsEnablingOnMainSectionRequisitesInput(buttonNames);
      WA.CR.form.bind('AfterSave', () => {        
        bindButtonsEnablingOnMainSectionRequisitesInput(buttonNames);
      });
      bindButtonsEnablingOnDetailSectionRequisitesInput(buttonNames);
    });
  };

  /**
   * Делает конопки доступными при вводе на реквизиты основного раздела
   * @param {Array<string>} buttonNames названия кнопок
   */
  function bindButtonsEnablingOnMainSectionRequisitesInput(buttonNames) {
    WA.CR.form.requisites.toArray().forEach((req) => {      
      req.controls.forEach((jControl) => {
        jControl.unbind('input.req keypress.req').one('input.req keypress.req', () => {          
          global.cards.enableButtonsOnFormChange(buttonNames);
        });
      });
    });
  }

  /**
   * Делает конопки доступными при вводе на реквизиты детального раздела
   * @param {Array<string>} buttonNames названия кнопок
   */
  function bindButtonsEnablingOnDetailSectionRequisitesInput(buttonNames) {
    const _bindOnRequisiteKeyPress = (row) => {
      row.requisites.toArray().forEach((req) => {
        req.bind('editModeChange', (isEditMode) => {
          if (isEditMode) {
            req.controls.forEach((jControl) => {
              jControl.one('input.req keypress.req', () => {
                global.cards.enableButtonsOnFormChange(buttonNames);
              });
            });
          } else {
            req.controls.forEach((jControl) => {
              jControl.unbind('input.req keypress.req');
            });
          }
        });
      });
    };

    const tables = WA.CR.form.controls.tables;
    for (const tableName in tables) {
      const table = tables[tableName];
      table.rows.toArray().forEach((row) => {
        _bindOnRequisiteKeyPress(row);
      });      
      table.bind('addRow', (row) => {        
        _bindOnRequisiteKeyPress(row);
      });
    };
  }

  /**
   * Установить доступность кнопок на ленте при изменении формы на основе режима доступности.
   * @since 5.5.2201
   */
  global.cards.setButtonsEnablingOnEnabledMode = function () {
    WA.CR.toolBar.buttons.getButtonsByEnabledMode(ACTION_ENABLED_MODE.ENABLED_ON_BROWSE).forEach(function (button) {
      button.disable();
    });
    WA.CR.toolBar.buttons.getButtonsByEnabledMode(ACTION_ENABLED_MODE.ENABLED_ON_EDIT).forEach(function (button) {
      button.enable();
    });
  };

  /**
   * Если на странице есть растягиваемый iframe предпросмотра,
   * сделаем изменения в вёрстке, чтобы контейнер вкладки растянулся на всю высоту.
   */
  global.cards.initResizablePreviewCard = () => {
    const jFrame = $('.CardForm_webbrowser');
    if (jFrame.hasClass('webbrowser_resizable')) {
      $('#scroller').addClass('scroller scroller_resizable');

      jFrame.css('top',`${jFrame.position().top || 8}px`);
      const framePosition = jFrame.position();
      jFrame.css({
        height: `calc(100% - ${Math.max(framePosition.top + 10, 10)}px)`,
        width: `calc(100% - ${Math.max(framePosition.left + 10, 10)}px)`,
      });
      const jInnerPanel = jFrame.parent();
      if (jInnerPanel.attr('name') && jInnerPanel.attr('name').includes('InnerPanel')) {
        // iFrame внутри контейнера "панели", которую тоже нужно растянуть
        jInnerPanel.css({
          height: '100%',
          width: `calc(100% - ${jInnerPanel.position().left}px)`,
        });
        const jPanelGroup = jInnerPanel.parent();
        const panelGroupPosition = jPanelGroup.position();
        jPanelGroup.css({
          height: `calc(100% - ${panelGroupPosition.top * 2}px)`,
          width: `calc(100% - ${panelGroupPosition.left}px)`,
        });
      }
    }
  };

})(window.Core);
